import image_1 from "./slide_1x2.png";
import image_2 from "./slide_2x2.png";
import image_3 from "./slide_3x2.png";

const images = [
  { url: image_1, id: "img_1", description: "automotive & aerospace" },
  { url: image_2, id: "img_2", description: "fitness & leisure" },
  { url: image_3, id: "img_3", description: "automotive & aerospace" },
  { url: image_1, id: "img_4", description: "health care/ digital health" },
  { url: image_2, id: "img_5", description: "fitness & leisure" },
  { url: image_3, id: "img_6", description: "health care/ digital health" },
  { url: image_1, id: "img_7", description: "health care/ digital health" },
  { url: image_1, id: "img_8", description: "health care/ digital health" }
];

export default images;
